<template>
  <div class="row m-0">
    <div
      v-for="(item ,index) in data"
      :key="index"

      class="col-sm-6 col-md-6 col-lg-4 p-1"
    >
      <Square
        :centered="true"
        :class="
          selections.find(s => JSON.stringify(s) === JSON.stringify(item)) ?
            'deepify-bg-success text-light ' + getSquareClass(index, data.length) :
            'bg-light ' + getSquareClass(index, data.length)
        "
        class="overflow-hidden"

        @click.native="selectItem(item)"
      >
        <div class="text-center px-3">
          <h6 class="text-uppercase p-0 m-0">
            {{ item[itemText] }}
          </h6>
        </div>
      </Square>
    </div>
  </div>
</template>

<script>
import Square from '@/components/core/Square.vue';

export default {
  name: 'Grid',
  components: {
    Square,
  },
  props: {
    value: {
      type: Array,
      required: true,
    },
    data: {
      type: Array,
      required: true,
    },
    limit: {
      type: Number,
      default: 1,
    },
    itemText: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      selections: null,
    };
  },
  watch: {
    value(val) {
      this.selections = val;
    },
    selections(val) {
      this.$emit('input', val);
      this.$emit('completed', val.length > 0);
    },
  },
  created() {
    this.selections = this.value;
  },
  methods: {
    getSquareClass(index, length) {
      if (index < 3) return 'rounded-bottom-2';
      if (length > 5 && index < length - (length % 3 > 0 ? length % 3 : 3)) return 'rounded-2';
      return 'rounded-top-2';
    },
    selectItem(value) {
      if (this.limit > 1) {
        // check the clicked item was added before
        const itemIndex = this.selections.findIndex(
          (s) => s[this.itemText] === value[this.itemText],
        );
        // if added
        if (itemIndex > -1) {
          // remove it from array
          this.selections.splice(itemIndex, 1);

          // if not added and the selection limit is not reached
        } else if (this.limit > this.selections.length) {
          // add item to the array
          this.selections.push(value);

          // if the selection limit is reached
        } else {
          this.$snotify.error('You cannot select more!');
        }
      } else {
        this.selections = [value];
      }
    },
  },
};
</script>
<style scoped>
.card {
  min-height: 90px;
}
</style>
